import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VsdSvg = function VsdSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#185ABD",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "m7.384 14.5 1.901-5.422H8.4L6.855 13.45 5.31 9.078h-.881L6.326 14.5zm4.526.075c1.297 0 2.119-.663 2.119-1.515 0-.574-.188-1.361-1.399-1.609l-.975-.217c-.637-.146-.829-.349-.829-.701 0-.488.473-.78 1.069-.78.6 0 1.08.225 1.148.87h.922c-.011-.878-.727-1.613-2.081-1.613-1.159 0-2.025.642-2.018 1.624.011.791.507 1.264 1.316 1.429l.998.217c.555.12.926.341.926.788 0 .502-.528.776-1.2.776-.633 0-1.136-.296-1.256-.844h-.945c.124 1.047 1.151 1.575 2.205 1.575m4.567-.075c1.958 0 2.87-1.005 2.87-2.741 0-1.665-.833-2.636-2.813-2.674l-.442-.004-.247-.002h-.24l-.502-.001h-.028V14.5zm.015-.754h-.49V9.831h.513c1.17 0 1.875.526 1.875 1.932 0 1.455-.784 1.983-1.898 1.983"
    })]
  });
};
export var Vsd = function Vsd(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: VsdSvg
  }));
};